/**************************************************
 * Nombre:       Seccion_Produccion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import React, {useEffect, useState} from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Usuario from "../Dialogos/Dialogo_Usuario";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";
import {CheckCircleOutline} from '@mui/icons-material'
import {where} from "firebase/firestore";
import useRecuperarColleccionListeningToda from "../../Servicios/BD/useRecuperarColleccionListeningToda";
import Tarjeta_Productos_Escogidos from "../Tarjeta/Tarjeta_Productos_Escogidos";


const Seccion_Produccion = () => {
    const [zonas, setZonas] = useState([]);
    const [zonasEscogidas, setZonasEscogidas] = useState([]);
    const [wheres, setWheres] = useState([where('estado', 'in', ['Produccion', 'Listo']), where('zona', '==', 'Cocina')]);
    const {data} = useRecuperarColleccionListeningToda({
        col: 'platosPedidos',
        orden: 'fecha',
        direccion: 'asc',
        wheres: wheres,

    })
    const [wheresDos, setWheresDos] = useState([where('estado', 'in', ['Produccion', 'Listo']), where('zona', '==', 'Bar')]);
    const {data: dataBar} = useRecuperarColleccionListeningToda({
        col: 'platosPedidos',
        orden: 'fecha',
        direccion: 'asc',
        wheres: wheresDos,

    })
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Usuario,
        titulo: 'Detalles del usuario',
        realizado: () => {
        }
    })

    const escogerZona = (nom) => {

        let zons = zonasEscogidas
        let index = zons.indexOf(nom);

        if (index >= 0) {
            zons.splice(index, 1);
            setZonasEscogidas(zons);

        } else {
            zons.push(nom);
            setZonasEscogidas(zons);
        }
    }

    useEffect(() => {
        obtenerCol('zonas').then((dox) => {
            setZonas(dox.data)
        })
    }, []);
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>

                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    {zonas.map((dox) => (
                        <Button
                            onClick={() => escogerZona(dox.nombre)}
                            variant={'contained'}
                            startIcon={<CheckCircleOutline/>} sx={{px: 2, borderRadius: 4}}>{dox.nombre}</Button>
                    ))}

                </Grid>



                <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    {data.map((dox) => (
                        <Tarjeta_Productos_Escogidos item={dox} click={() => {
                        }}/>
                    ))}
                </Grid>

                <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    {dataBar.map((dox) => (
                        <Tarjeta_Productos_Escogidos item={dox} click={() => {
                        }}/>
                    ))}
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Seccion_Produccion
